import { render, staticRenderFns } from "./deAllocation.vue?vue&type=template&id=5b4e5f84&"
import script from "./deAllocation.vue?vue&type=script&lang=js&"
export * from "./deAllocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports